import { LanguagesService } from '@alpha-core/platform-ui';
import { Component, DestroyRef, inject, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { combineLatest, map } from 'rxjs';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CaseService } from '../../services/case.service';
import { DashboardService } from './dashboard.service';

@Pipe({
    standalone: true,
    name: 'count',
})
export class CountTransFormPipe implements PipeTransform {
    transform(value: any) {
        if (value === undefined || value === null || isNaN(value)) {
            return '-';
        }
        return value;
    }
}
@Component({
    selector: 'app-inbox-dashboard',
    standalone: true,
    imports: [DividerModule, ButtonModule, CountTransFormPipe, TranslatePipe],
    templateUrl: './dashboard.component.html',
})
export class DashboardComponent {
    private dashboardService = inject(DashboardService);
    private caseService = inject(CaseService);
    private languageService = inject(LanguagesService);

    config: { display: boolean; collapsible: boolean; cards: Array<any> } | null = null;
    cards: Array<any> = [];
    dashboardData: Array<any> | null = null;
    collapsed: boolean = false;
    destroy$ = inject(DestroyRef);
    constructor() {
        this.getDashBoardData();
    }

    private getDashBoardData() {
        combineLatest([
            this.caseService.dashBoardData$,
            this.dashboardService.dashboardConfig.pipe(map((config) => this.languageService.translateConfig(config))),
        ])
            .pipe(takeUntilDestroyed())
            .subscribe(([dashboardData, config]) => {
                this.dashboardData = dashboardData || [];
                this.config = config;
                this.calculateCardsCount();
            });
    }

    private calculateCardsCount() {
        if (!this.dashboardData || !this.config?.cards) {
            this.cards = [];
            return;
        }
        const dashoardMap = new Map(this.dashboardData.map((d) => [d.status?.trim(), parseInt(d.count, 10)]));
        let totalCount = 0;
        dashoardMap.forEach((c) => (totalCount += c));
        const uniqueStatus = new Set();
        const itemCounts = this.config.cards
            .filter((item) => {
                const status = item.status?.trim();
                if (status === 'other') return false;
                if (uniqueStatus.has(status)) return false;

                uniqueStatus.add(status);
                return true;
            })
            .map((item) => dashoardMap.get(item.status?.trim()) || 0)
            .reduce((a, c) => a + c, 0);
        dashoardMap.set('other', Math.max(0, totalCount - itemCounts));
        this.cards = this.config.cards.map((item) => {
            return { ...item, count: dashoardMap.get(item.status?.trim()) || 0 };
        });
    }

    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }
}
